import '../../../index.css';
import React, { useMemo, forwardRef, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {Grid,Paper, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTheme } from '@material-ui/core/styles';
import { getModulos } from '../../domain/api/EvbiApi';
import { useParams, useLocation } from 'react-router-dom';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import { ListadoModulos } from './ListadoModulos';


export const ListModulos = ({ handledEditSettings, handleSupervisor }) => {
    const [id_list, setid_list] = useState("");
    const [list_modulos, setlist_modulos] = useState([]);
    const dispatch = useDispatch();
    const theme = useTheme();
    const location = useLocation();

    let to = `/basculas/mediciones/${id_list}`;
    const history = useHistory();
 

    const renderLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} />),
        [to, id_list],
    );

    let toUser = `/mediciones/user/${id_list}`;
    const renderUserMachineLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={toUser} ref={ref} {...itemProps} />),
        [toUser],
    );
    let toAlcolimetria = `/basculas/alcoholimetria/${id_list}`;
    const alcolimetriaLink = useMemo(() => forwardRef((itemProps, ref) => <RouterLink to={toAlcolimetria} ref={ref} {...itemProps} />),
        [to, id_list],
    );

  
    const handledViewImc = (id) => {
        setid_list(id);
    };

    const handledViewUsers = (id, name) => {
        const params = {
            nameBascula: name
        };
        setTimeout(() => {
            history.push(`/mediciones/user/${id}`, params);
            setid_list(id);
        }, 500);
    };

    const handledViewAcolimetria = (id, name) => {
        const params = {
            nombre: name
        };
        setTimeout(() => {
            history.push(`/basculas/alcoholimetria/${id}`, params);
            setid_list(id);
        }, 2000);
    };


    const handledViewPolls = (id) => {
        history.push(`/poll/encuestas/${id}`);
        setid_list(id);
    };

    let { id } = useParams();
    const { nameBascula } = location.state;
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const primaryColor = theme.palette.primary.main;
    useEffect(async () => {
        const result = await getModulos(dispatch, id)
        setlist_modulos(result.respuesta)
    }, [])

    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <br></br>

                <MigaPan
                    namePage={`Modulos ${nameBascula}`}
                    to="/"
                    namePage2="Estaciones"
                    to2="/basculas/"
                >
                    Home
                </MigaPan>
            </Grid>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} style={{marginTop:'5%'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Typography variant="h6" style={{
                                textAlign: 'left', fontSize: '25px',
                                fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
                                color: primaryColor, marginBottom: "3%", fontWeight: 'bold',
                                marginLeft: '8%'
                            }}>Tipo de Módulo</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="h6" style={{
                                textAlign: 'left', fontSize: '25px',
                                fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
                                color: primaryColor, marginBottom: "3%", fontWeight: 'bold',
                                marginLeft: '8%'
                            }}>Estado</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h6" style={{
                                textAlign: 'left', fontSize: '25px',
                                fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
                                color: primaryColor, marginBottom: "3%", fontWeight: 'bold',
                                marginLeft: '1%'
                            }}>Última Conexión</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h6" style={{
                                textAlign: 'left', fontSize: '25px',
                                fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
                                color:primaryColor, marginBottom: "3%", fontWeight: 'bold',
                                marginLeft: '-15%'
                            }}>Última Medición</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {list_modulos === undefined || list_modulos.length === 0 ? (
                <Typography variant="h4" style={{ textAlign: 'center', marginLeft: '2%', fontSize: '25px' }}>
                    No hay módulos disponibles.
                </Typography>
            ) : (
                <Paper>
                    <ListadoModulos
                        rows={list_modulos}
                        renderLink={renderLink}
                        renderUserMachineLink={renderUserMachineLink}
                        alcolimetriaLink={alcolimetriaLink}
                        handleClick={handleClick}
                        handleClose={handleClose}
                        handledViewImc={handledViewImc}
                        handledViewUsers={handledViewUsers}
                        handledViewAcolimetria={handledViewAcolimetria}
                        handledViewPolls={handledViewPolls}
                        handledEditSettings={handledEditSettings}
                        handleSupervisor={handleSupervisor}
                    />

                </Paper>
            )}
        </>
    );
};
